import React, { useEffect, useState } from 'react';
import { getTheme, useThemeMode } from '../theme';
import { Button, Dialog } from '../components/ui';
import { modApi, type BlockedUser } from '../components/moderation/moderationApi';
import { SUPPORT_EMAIL, SUPPORT_PATH, SupportForm } from '../pages/SupportPage';

// AS1c · Profil: blockerade användare (häv blockering) och kontakt/support.

function SectionLabel({ children }: { children: React.ReactNode }) {
  const T = getTheme(useThemeMode().mode);
  return <div style={{ color: T.textSub, fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 8 }}>{children}</div>;
}

export function BlockedUsersSection({ cardStyle }: { cardStyle: React.CSSProperties }) {
  const T = getTheme(useThemeMode().mode);
  const [blocks, setBlocks] = useState<BlockedUser[] | null>(null);
  const [error, setError] = useState('');
  useEffect(() => { modApi.blocks().then(setBlocks).catch(e => { setError(e.message); setBlocks([]); }); }, []);
  const unblock = (b: BlockedUser) => modApi.unblock(b.email)
    .then(() => setBlocks(prev => (prev ?? []).filter(x => x.email !== b.email)))
    .catch(e => setError(e.message));
  return (
    <div style={{ ...cardStyle, marginBottom: 16 }}>
      <SectionLabel>Blockerade användare</SectionLabel>
      {blocks === null ? <p style={{ color: T.textSub, fontSize: 13, margin: 0 }}>Hämtar…</p>
        : blocks.length === 0 ? <p style={{ color: T.textSub, fontSize: 13, lineHeight: 1.55, margin: 0 }}>Du har inte blockerat någon. Blockera via ⋯ vid ett meddelande, en bild, en annons eller en medlem.</p>
        : (
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 4 }}>
            {blocks.map(b => (
              <li key={b.email} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, minHeight: 44 }}>
                <span style={{ color: T.text, fontSize: 15, fontWeight: 600, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.name}</span>
                <Button size="sm" variant="secondary" onClick={() => unblock(b)}>Häv blockering</Button>
              </li>
            ))}
          </ul>
        )}
      {error && <p role="alert" style={{ color: T.danger, fontSize: 13, fontWeight: 600, margin: '8px 0 0' }}>{error}</p>}
    </div>
  );
}

export function SupportSection({ cardStyle, email, name }: { cardStyle: React.CSSProperties; email?: string | null; name?: string | null }) {
  const T = getTheme(useThemeMode().mode);
  const [open, setOpen] = useState(false);
  return (
    <div style={{ ...cardStyle, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14, flexWrap: 'wrap' }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <SectionLabel>Kontakt och support</SectionLabel>
        <p style={{ color: T.textSub, fontSize: 13, lineHeight: 1.55, margin: 0 }}>
          Frågor eller problem? Mejla <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: T.amber }}>{SUPPORT_EMAIL}</a> eller skriv till oss. <a href={SUPPORT_PATH} style={{ color: T.amber }}>Supportsidan</a>
        </p>
      </div>
      <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>Skriv till supporten</Button>
      <Dialog open={open} onClose={() => setOpen(false)} title="Kontakt och support" width={560}>
        <SupportForm defaultEmail={email} defaultName={name} />
      </Dialog>
    </div>
  );
}
